module.exports = __webpack_public_path__ + "static/img/know_how_4.e649d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/know_how_4.jpg
// module id = BmEs
// module chunks = 0